<div class="docs-layout">
  @if (sideNavVisible()) {
    <aside class="docs-sidenav" id="docs-sidenav" aria-label="Documentation navigation">
    <nav>
      @for (group of navGroups; track group.id) {
        <div class="docs-nav-group">
          <button type="button" class="docs-nav-group-header" (click)="toggleGroup(group.id)" [attr.aria-expanded]="isExpanded(group.id)">
            <span>{{ group.label }}</span>
            <span class="docs-chevron" [class.expanded]="isExpanded(group.id)" aria-hidden="true">›</span>
          </button>
          @if (isExpanded(group.id)) {
            <ul class="docs-nav-items">
              @for (item of group.items; track item.id) {
                <li>
                  <a
                    href="javascript:void(0)"
                    class="docs-nav-link"
                    [class.active]="activeItemId() === item.id"
                    [attr.aria-current]="activeItemId() === item.id ? 'page' : null"
                    (click)="selectItem(item.id)">
                    {{ item.label }}
                  </a>
                </li>
              }
            </ul>
            }
          </div>
        }
        </nav>
    </aside>
  }

  <main class="docs-content">
    <button
      type="button"
      class="docs-sidenav-toggle"
      (click)="toggleSideNav()"
      [attr.aria-expanded]="sideNavVisible()"
      aria-controls="docs-sidenav"
      [attr.aria-label]="sideNavVisible() ? 'Hide navigation' : 'Show navigation'">
      <span class="docs-sidenav-toggle-icon" [class.collapsed]="!sideNavVisible()" aria-hidden="true">‹</span>
      <span>{{ sideNavVisible() ? 'Hide menu' : 'Show menu' }}</span>
    </button>

    @if (activeItemId() === 'audit') {
      <iframe [src]="auditDocsUrl" style="width:100%; height:100vh; border:1px solid #e3e6ea;"></iframe>
    }
    @if (activeItemId() === 'swipesum-connect') {
      <iframe src="https://docs.getfwd.com/docs/" style="width:100%; height:100vh; border:1px solid #e3e6ea;"></iframe>
    }
    @if (activeItemId() === 'ai-tools') {
      <iframe [src]="aiToolsDocsUrl" style="width:100%; height:100vh; border:1px solid #e3e6ea;"></iframe>
    }
    @if (activeItemId() === 'api-overview') {
      <iframe [src]="apiDocsUrl" style="width:100%; height:100vh; border:1px solid #e3e6ea;"></iframe>
    }
    @if (activeItemId() === 'campfire') {
      <iframe style="width:100%; height:100vh; border:1px solid #e3e6ea;" src="https://docs.google.com/document/d/e/2PACX-1vTKdk84M_c1R1aOTZIeIZJ8NuQWlln-mjdOyrvZzLmjjFWtqJVBUgepA2nxjO7wQjzLiIKTCoYycz2S/pub?embedded=true"></iframe> 
    }
  </main>
</div>
